export const ReusableAbout = ({ IMAGE_PATH }) => {

    return (
        <>
            <section className="about-section" style={{ backgroundImage: `url(${IMAGE_PATH}/about_frame.svg);background-repeat: no-repeat` }}>
                <div className="container pt-4 pb-3">
                    <div className="row pt-4" id="about2a">
                        <div className="col-sm-5 reusable-about2 " id="about2" 
                        >

                            <img className="image_about" src={`${IMAGE_PATH}/reusable_about.jpeg`} alt="Reusable About" />
                        </div>
                        <div className="col-sm-7 mt-5" id="about1">
                            <h1 className="mb-5">Benifits of using <span style={{ color: '#00675B' }}>Repository</span></h1>
                            <div className="step-box" style={{ margin: 0, padding: '0px' }}>
                                <h1 className="d-none d-sm-block reusable-step-box-title" 
                                >01</h1>
                                <div className="circle" style={{ position: 'absolute', left: 33, top: -3 }}></div>

                                <div className="step-number">01</div>
                                <div className="step-content">
                                    <p className="step-title" style={{ fontWeight: 700 }}>Accelerated Development</p>
                                    <p className="step-description">Reuse pre-built, tested code components to significantly reduce development time and effort on new projects.</p>
                                </div>
                            </div>

                            <div className="step-box" style={{ margin: 0, padding: '0px' }}>
                                <h1 className="d-none d-sm-block reusable-step-box-title" >02</h1>
                                <div className="circle" style={{ position: 'absolute', left: 33, top: -3 }}></div>

                                <div className="step-number">02</div>
                                <div className="step-content">
                                    <p className="step-title" style={{ fontWeight: 700 }}>Improved Consistency and Quality</p>
                                    <p className="step-description">Utilizing standardized components ensures a more consistent codebase and leverages code that has likely been tested and refined.</p>
                                </div>
                            </div>

                            <div className="step-box" style={{ margin: 0, padding: '0px' }}>
                                <h1 className="d-none d-sm-block reusable-step-box-title" >03</h1>
                                <div className="circle" style={{ position: 'absolute', left: 33, top: -3 }}></div>

                                <div className="step-number" >03</div>
                                <div className="step-content">
                                    <p className="step-title" style={{ fontWeight: 700 }}>Enhanced Collaboration</p>
                                    <p className="step-description">A central repository facilitates sharing and collaboration among teams, preventing duplication of effort and promoting knowledge sharing</p>
                                </div>
                            </div>
                            <div className="step-box" style={{ margin: 0, padding: '0px' }}>
                                <h1 className="d-none d-sm-block reusable-step-box-title" >04</h1>
                                
                                <div className="circle" style={{ position: 'absolute', left: 33, top: -3 }}></div>

                                <div className="step-number" id="step_41">04</div>
                                <div className="step-content">
                                    <p className="step-title" style={{ fontWeight: 700 }}>Reduced Maintenance Overhead</p>
                                    <p className="step-description">Maintaining a single source of well-tested components can simplify updates and reduce the overall effort required for long-term maintenance</p>
                                </div>
                            </div>
                            <div className="step-box" style={{ margin: 0, padding: '0px' }}>
                                <h1 className="d-none d-sm-block reusable-step-box-title" >05</h1>

                               
                                <div className="circle" style={{ position: 'absolute', left: 33, top: -3 }}></div>

                                <div className="step-number" id="step_41">05</div>
                                <div className="step-content">
                                    <p className="step-title" style={{ fontWeight: 700 }}>Clear Code Usage Rights</p>
                                    <p className="step-description">Using this repository ensures you're working with code where the usage rights are clear, avoiding copyright issues.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}